/**
 * Consumer Portal Hints
 *
 * Contextual hints for the consumer portal loan application journey.
 * Targets elements tagged with `data-astor-id` on consumer portal pages.
 */

import type { HintConfig } from './hint-config.types';

export const consumerPortalHints: HintConfig[] = [
  {
    id: 'consumer-loan-application',
    targetAstorId: 'dashboard-quick-actions',
    title: 'hints.consumer.loanApplication.title',
    description: 'hints.consumer.loanApplication.description',
    portal: 'consumer',
    route: '/dashboard',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'consumer-upload-documents',
    targetAstorId: 'document-upload-area',
    title: 'hints.consumer.uploadDocuments.title',
    description: 'hints.consumer.uploadDocuments.description',
    portal: 'consumer',
    route: '/documents',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'consumer-application-status',
    targetAstorId: 'application-status-tracker',
    title: 'hints.consumer.applicationStatus.title',
    description: 'hints.consumer.applicationStatus.description',
    portal: 'consumer',
    route: '/applications',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'top',
  },
  {
    id: 'consumer-dashboard-upload-documents',
    targetAstorId: 'dashboard-upload-documents',
    title: 'hints.consumer.uploadFromDashboard.title',
    description: 'hints.consumer.uploadFromDashboard.description',
    portal: 'consumer',
    route: '/dashboard',
    showOnce: true,
    priority: 'medium',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'consumer-dashboard-view-timeline',
    targetAstorId: 'dashboard-view-timeline',
    title: 'hints.consumer.viewTimeline.title',
    description: 'hints.consumer.viewTimeline.description',
    portal: 'consumer',
    route: '/dashboard',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'bottom',
  },
  {
    id: 'consumer-start-new-application',
    targetAstorId: 'start-new-application',
    title: 'hints.consumer.startApplication.title',
    description: 'hints.consumer.startApplication.description',
    portal: 'consumer',
    route: '/applications',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
];
